import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=55c72614"
import script from "./appMenu.vue?vue&type=script&lang=js"
export * from "./appMenu.vue?vue&type=script&lang=js"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=55c72614&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports